import {
  KPI_CRITICAL_BADGE_COLOR,
  KPI_OPTIMAL_BADGE_COLOR,
  KPI_CAUTION_BADGE_COLOR,
} from '../themes/tokens';

export const useKpiBadgeColor = (result: string): string => {
  switch (result.toLowerCase()) {
    case 'at benchmark':
    case 'at':
    case 'above':
      return KPI_OPTIMAL_BADGE_COLOR;

    case 'met benchmark':
    case 'met':
      return KPI_CAUTION_BADGE_COLOR;

    default:
      return KPI_CRITICAL_BADGE_COLOR;
  }
};
